
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[hostname]/Jobs/[[...id]]",
      function () {
        return require("private-next-pages/_sites/[hostname]/Jobs/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[hostname]/Jobs/[[...id]]"])
      });
    }
  